var map = {
	"./en.json": 69,
	"./fr.json": 382
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 381;


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n ^\.\/.*\.json$
// module id = 381
// module chunks = 1